// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import ListaPagosVendedor from '../../../componentesEspeciales/desembolsosPagos/listaPagosVendedor';
import { formatearMoneda } from '../../../funcionesDatos/Moneda';
import { formatearFechaHora } from '../../../funcionesDatos/fechas';
// estilos
import '../../../estilos/usuario.css';



function PagosVendedor() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]                 = useState(false);
    const [reservas, setReservas]                 = useState([]);
    const [resumenPagos, setResumenPagos]         = useState(null);
    const [paginaActual, setPaginaActual]         = useState(1);
    const [totalPaginas, setTotalPaginas]         = useState(1);
    const [totalReservas, setTotalReservas]       = useState(0);
    const [ahoraPagos, setAhoraPagos]             = useState(null);
    const reservasPorPagina                       = 10;
    const cargandoFinal                           = Boolean(cargandoUsuario) || Boolean(cargando);

    function mostrarMoneda(valor) {
        return formatearMoneda(Number(valor || 0), "COP");
    }

    function mostrarFechaHora(fecha) {
        return formatearFechaHora(fecha) || "NA";
    }

    function irPaginaAnterior() {
        setPaginaActual((pagina) => Math.max(1, pagina - 1));
    }

    function irPaginaSiguiente() {
        setPaginaActual((pagina) => Math.min(totalPaginas, pagina + 1));
    }


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
           // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const resPagos = await axios.post("/obtener-pagos-individual-vendedor", {
                    params: {
                        idUsuario: usuario.idUsuario,
                        pagina: paginaActual,
                        limite: reservasPorPagina,
                    }
                });

                const data = resPagos?.data || {};

                setReservas(Array.isArray(data?.reservas) ? data.reservas : []);
                setResumenPagos(data?.resumen || null);
                setPaginaActual(Number(data?.pagina || 1));
                setTotalPaginas(Number(data?.totalPaginas || 1));
                setTotalReservas(Number(data?.totalReservas || 0));
                setAhoraPagos(data?.ahora || null);
                
            }
            catch (err) {
                console.log("Error obteniendo pagos del vendedor:", err);
                setReservas([]);
                setResumenPagos(null);
                setTotalPaginas(1);
                setTotalReservas(0);
                setAhoraPagos(null);
            }
            finally { setCargando(false); }
        })();
    }, [usuario, cargandoUsuario, paginaActual, navigate]);
    








    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Pagos</h1>
                    </div>
                </div>
            </div>
            


            <div className="container mb-4">
                <div className="row g-3">
                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <span className="text-secondary fw-semibold">Disponible para pago</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(resumenPagos?.montoDisponible)}</h3>
                                <small className="text-secondary">{resumenPagos?.totalDisponible || 0} reserva(s) listas</small>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <span className="text-secondary fw-semibold">Pendiente</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(resumenPagos?.montoPendiente)}</h3>
                                <small className="text-secondary">{resumenPagos?.totalPendiente || 0} reserva(s)</small>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <span className="text-secondary fw-semibold">Programado</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(resumenPagos?.montoProgramado)}</h3>
                                <small className="text-secondary">{resumenPagos?.totalProgramado || 0} reserva(s)</small>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <span className="text-secondary fw-semibold">Pagado</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(resumenPagos?.montoPagado)}</h3>
                                <small className="text-secondary">{resumenPagos?.totalPagado || 0} reserva(s)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="alert alert-light border rounded-4 mt-3 mb-0">
                    <strong>Total histórico:</strong> {mostrarMoneda(resumenPagos?.montoTotalHistorico)} · <strong>Reservas:</strong> {totalReservas} · <strong>Retenidas:</strong> {resumenPagos?.totalRetenido || 0} · <strong>Fallidas:</strong> {resumenPagos?.totalFallido || 0} · <strong>Último cálculo:</strong> {mostrarFechaHora(ahoraPagos)}
                </div>
            </div>

            <ListaPagosVendedor
                reservas={reservas}
                resumenPagos={resumenPagos}
                paginaActual={paginaActual}
                totalPaginas={totalPaginas}
                totalReservas={totalReservas}
                ahoraPagos={ahoraPagos}
                reservasPorPagina={reservasPorPagina}
                irPaginaAnterior={irPaginaAnterior}
                irPaginaSiguiente={irPaginaSiguiente}
                idUsuario={usuario.idUsuario}
            />
            
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default PagosVendedor;